import {usePopper} from "react-popper"
import React, {useState} from "react"
import {use_on_hover_event} from "./hooks"
import Portal from "./portal"

const tooltip_container_id = "tooltip_container"

const Tooltip = ({
  target,
  placement = "auto",
  modifiers = [],
  children
}) => {
  const [tooltip_element, set_tooltip_element] = useState(null)
  const [arrow_element, set_arrow_element] = useState(null)
  const [is_visible, set_is_visible] = useState(false)
  const show = () => set_is_visible(true)
  const hide = () => set_is_visible(false)
  use_on_hover_event(target, show, hide)
  use_on_hover_event(tooltip_element, show, hide)
  const {styles, attributes} = usePopper(target, tooltip_element, {
    placement,
    modifiers: [
      ...modifiers,
      {name: "arrow", options: {element: arrow_element}}
    ]
  })

  if (!is_visible) return null

  return (
    <div
      ref={set_tooltip_element}
      style={styles.popper}
      className="tooltip"
      {...attributes.popper}
    >
      <div
        className="arrow"
        ref={set_arrow_element}
        // no idea why but I had to correct the position of the arrow here
        style={{...styles.arrow, left: "-3px"}}
      />
      {children}
    </div>
  )
}

export function TooltipPortal(props) {
  return (
    <Portal id={tooltip_container_id}>
      <Tooltip {...props} />
    </Portal>
  )
}

export default Tooltip
